import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import { ReduxConnect } from "../../../toolkit/decorators/Artifact";
import {
  ExternoDetalleDispatcher,
  externoDetalleDispatcher
} from "./ExternoDetalle.dispatcher";
import {
  ExternoDetalleStore,
  externoDetalleStore
} from "./ExternoDetalle.store";
import ExternoDetalleComponent from "../../components/externoDetalle";

interface Props extends ExternoDetalleStore, ExternoDetalleDispatcher {}
interface State {}

@ReduxConnect(externoDetalleStore, externoDetalleDispatcher)
export default class ExternoDetalleContainer extends React.Component<
  Props,
  State
> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Externo Detalle" />
          <ExternoDetalleComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
